export default __webpack_public_path__ + "static/techspark-logo-60513eb35c95f304afcc6b91352212d0.svg";